import {Regions} from "./../model/Region"
import {UniversityBranches} from "./../model/UniversityBranch"
import {Specialities} from "./../model/Speciality"
import {Demand, DemandList} from "../model/Demand"
import {Divisions} from "../model/Division"

import {SheetData} from "./../Excel/export"
import {getCompany, lpad, RowData} from "./../model/utils/utils"
import {User} from "../model/User";
import {
    Columns, makeEmptyRow,
    Rows,
    specialityColumns,
    specialityMerges,
    universityColumns,
    universityMerges,
    makeUniversityData, makeSpecialityData, employeeColumns, border, makeSheet,
    traineeColumns, demandColumnToYear, CURRENT_YEAR, IS_SUMMER
} from "./common";
import {practiceTitleMap, Trainee} from "../model/Trainee";

const columnsOrder = [
    ...specialityColumns,
    Columns.isOpk,
    ...employeeColumns,
    ...traineeColumns,
    Columns.citizenship,
    Columns.target,
    Columns.practiceType,
    Columns.isPracticePaid,
//    Columns.months,
    Columns.details,
    ...universityColumns,
]

type Data = {
    demand: DemandList
    divisions: Divisions
    regions: Regions
    specialities: Specialities
    universityBranches: UniversityBranches
    meta: {
        company: string
        user: User
    }
}

const composeData = ({
    demand,
    divisions,
    regions,
    specialities,
    universityBranches,
}: Data): RowData[] => {
    let rawResult: RowData[] = []

    demand.map(({
        id,
        companyId,
        courseOfStudyName,
        specialityId,
        regionId,
        universityBranchId,
        traineeTotal,
        traineeByYear,
        trainees,
        nationalProjectName,
        englishLevelName,
        languageName,
        isPracticePaidName,
        monthNames
    }: Demand) => {
        if (!traineeTotal) {
            return
        }

        const {
            isOpk,
        } = getCompany(divisions, companyId)

        let row = makeEmptyRow(columnsOrder, {
            ...makeSpecialityData({
                id,
                courseOfStudyName,
                divisions,
                companyId,
                specialities,
                specialityId,
                nationalProjectName,
                englishLevelName,
                languageName,
            }),
            ...makeUniversityData({
                regions,
                regionId,
                universityBranches,
                universityBranchId,
            }),
            ...traineeColumns.reduce((row, column) => ({...row, [column]: traineeByYear[demandColumnToYear[column]] || ""}), {}),
            [Columns.isOpk]: (isOpk/* && specialitiesOpk.has(specialityId)*/) ? "Да" : "Нет",
//            [Columns.months]: monthNames().join(', '),
            [Columns.isPracticePaid]: isPracticePaidName,
        })

        rawResult = rawResult.concat([row])

        trainees.filter(({demandYear}: Trainee) => demandYear >= (IS_SUMMER ? CURRENT_YEAR : CURRENT_YEAR - 1)).map(({
            id: employeeId,
            citizenship,
            target,
            opk,
            details,
            practiceType,
            demand,
            gpa,
        }: Trainee) => {
            let row = makeEmptyRow(columnsOrder, {
                ...makeSpecialityData({
                    id: lpad(id) + "." + lpad(employeeId),
                    courseOfStudyName,
                    divisions,
                    companyId,
                    specialities,
                    specialityId,
                    nationalProjectName,
                    englishLevelName,
                    languageName,
                }),
                ...makeUniversityData({
                    regions,
                    regionId,
                    universityBranches,
                    universityBranchId,
                }),
                [Columns.target]: target ? (opk ? "Целевик ОПК" : "Целевик") : "",
                [Columns.isOpk]: (isOpk/* && specialitiesOpk.has(specialityId)*/) ? "Да" : "Нет",
                [Columns.details]: details,
                [Columns.citizenship]: citizenship,
                [Columns.practiceType]: practiceTitleMap[practiceType],
                [Columns.employeesCurrentYear]: demand,
                [Columns.employeesCurrentYearGpa]: gpa || "",
                [Columns.isPracticePaid]: isPracticePaidName,
//                [Columns.months]: "",
            })

            rawResult = rawResult.concat([row])
        })
    })

    return rawResult
}

export const traineesWs = (data: Data): SheetData => makeSheet({
    sheetTitle: "Практика студентов",
    title1: "Данные о трудоустройстве и потребностях Госкорпорации «Росатом» в трудоустройстве",
    title2: "студентов образовательных организаций, прохождении студентами практики и стажировки",
    company: data.meta.company,
    fullName: data.meta.user.executor.fullName,
    columnsOrder,
    heading1Row: {
        [employeeColumns[0]]:  {s: {border, font: {bold: true}, alignment: {wrapText: true, horizontal: "center", vertical: "top"}},    v: "Общие практики"},
        [Columns.citizenship]: {s: {border, font: {bold: true}, alignment: {wrapText: true, horizontal: "center", vertical: "top"}},    v: "Гражданство практикантов"},
        [Columns.target]: {s: {border, font: {bold: true}, alignment: {wrapText: true, horizontal: "center", vertical: "top"}},    v: "Целевик"},
        [Columns.isOpk]: {s: {border, font: {bold: true}, alignment: {wrapText: true, horizontal: "center", vertical: "center"}}, v: "Является ли ОПК"},
        [Columns.practiceType]: {s: {border, font: {bold: true}, alignment: {wrapText: true, horizontal: "center", vertical: "top"}},    v: "Тип практики"},
        [Columns.isPracticePaid]: {s: {border, font: {bold: true}, alignment: {wrapText: true, horizontal: "center", vertical: "top"}},    v: "Со студентами заключается трудовой договор/ученический договор с оплатой"},
//        [Columns.months]: {s: {border, font: {bold: true}, alignment: {wrapText: true, horizontal: "center", vertical: "top"}},    v: "В какие месяцы 2025 года вы готовы принимать практикантов"},
        [Columns.details]: {s: {border, font: {bold: true}, alignment: {wrapText: true, horizontal: "center", vertical: "top"}},    v: "Комментарии"},
    },
    heading2Row: {
        [employeeColumns[0]]: {s: {border, font: {bold: true}, alignment: {wrapText: true, horizontal: "center", vertical: "top"}},    v: "Факт"},
        [traineeColumns[0]]:  {s: {border, font: {bold: true}, alignment: {wrapText: true, horizontal: "center", vertical: "top"}},    v: "Прогноз"},
    },
    merges: [
        ...specialityMerges,

        [employeeColumns[0], Rows.Heading1, traineeColumns[traineeColumns.length - 1],    Rows.Heading1],
        [employeeColumns[0], Rows.Heading2, employeeColumns[1], Rows.Heading2],
        [traineeColumns[0], Rows.Heading2, traineeColumns[traineeColumns.length - 1],    Rows.Heading2],

        [Columns.citizenship, Rows.Heading1, Columns.citizenship, Rows.Heading3],
        [Columns.target, Rows.Heading1, Columns.target, Rows.Heading3],
        [Columns.isOpk, Rows.Heading1, Columns.isOpk, Rows.Heading3],
        [Columns.practiceType, Rows.Heading1, Columns.practiceType, Rows.Heading3],
        [Columns.isPracticePaid, Rows.Heading1, Columns.isPracticePaid, Rows.Heading3],
//        [Columns.months, Rows.Heading1, Columns.months, Rows.Heading3],
        [Columns.details, Rows.Heading1, Columns.details, Rows.Heading3],

        ...universityMerges,
    ],
    data: composeData(data),
    specialities: data.specialities,
})
